/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SmsOtpVerifyRequest = {
  properties: {
    type: {
      type: 'Enum',
      isRequired: true,
    },
    code: {
      type: 'string',
      isRequired: true,
    },
    phone: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
